import React from 'react';
import styled from 'styled-components';

const BestOffersTitle = () => {
  return (
    <Wrapper>
      <div className="container1">
        <div className="categories-header1">
          <p className="categories-text1 ps-lg-5 ps-0">Today's Best Offers</p>
        </div>
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.section`
  padding-top:20px;

  .container1 {
    max-width: 1135px;
    width: 100%;
    margin: 0 auto;
    padding: 0 20px;
  }

  .categories-header1 {
    .categories-text1 {
      font-size: 20px;
      font-weight: bold;
      color: #ef4766;
      margin: 0;
    }
  }

  @media (max-width: 576px) {
   padding-top:5px !important;
    .categories-text1 {
      font-size: 16px;      
    }
    .container1 {
      padding: 0 0px !important;
    }
  }
`;

export default BestOffersTitle;
